import { ref } from "vue";
import { FormInstance } from "element-plus";

export const formPersonalDetails = ref<FormInstance>();
export const formEmployeeDetails = ref<FormInstance>();
export const formMemberDetails = ref<FormInstance>();
export const formReviewMember = ref<FormInstance>();